import React, {useState, useEffect} from 'react'
import axios from "axios";
import {Button, TextField, Tabs, Tab} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import CustomPagination from "../../components/Pagination/CustomPagination";
import ComponentCard from "../../components/ComponentCard/ComponentCard";
import { ThemeProvider } from "@mui/material/styles";
import { darkTheme } from '../../components/darkTheme';


const Search = () => {
  const [type, setType] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [content, setContent] = useState([]);
  const [numOfPages, setNumOfPages] = useState();
  const [notfound, setNotfound] = useState("");

  const fetchSearch = async () => {
    try {
      const { data } = await axios.get(
        `https://api.themoviedb.org/3/search/${type ? "tv" : "movie"}?api_key=${
          process.env.REACT_APP_API_KEY
        }&language=en-US&query=${searchText}&page=${page}&include_adult=false`
      );
      setContent(data.results);
      setNumOfPages(data.total_pages);
      setNotfound(searchText && !content.length ? (type ? "No Series Found" : "No Movies Found"): "");

      // console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
    fetchSearch();
    // eslint-disable-next-line
  }, [type, page]);

  return (
      <div>
          <span className='pageTitle'>Search for your favourite movie or series</span>
          <ThemeProvider theme={darkTheme}>
              <div className="search">
                  <TextField
                    style={{ flex: 1 }}
                    className="searchBox"
                    label="Search"
                    variant="filled"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <Button
                    onClick={fetchSearch}
                    variant="contained"
                    style={{ marginLeft: 10 }}
                  >
                      <SearchIcon fontSize="large" />
                  </Button>
              </div>
              <Tabs
                value={type}
                indicatorColor="primary"
                textColor="primary"
                onChange={(event, newValue) => {
                setType(newValue);
                setPage(1);
                }}
                style={{ paddingBottom: 5 }}
                aria-label="disabled tabs example"
              >
                <Tab style={{ width: "50%" }} label="Matching Movies" />
                <Tab style={{ width: "50%" }} label="Matching TV Series" />
              </Tabs>
          </ThemeProvider>

          <div className="trending">
          {content &&
          content.map((c) => (
            <ComponentCard
              key={c.id}
              id={c.id}
              poster={c.poster_path}
              title={c.title || c.name}
              date={c.first_air_date || c.release_date}
              media_type={type ? "tv" : "movie"}
              vote_average={c.vote_average}
            />
          ))}

          <h2>{notfound}</h2>
      </div>
      {numOfPages > 1 && (
        <CustomPagination setPage={setPage} numOfPages={numOfPages} />
      )}
    </div>
  )
}

export default Search